import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EProsActionTypes {
  Set = 'NEW_REVIEW/PROS/SET',
}

export type TSetProsRating = ITypedReduxAction<EProsActionTypes.Set, string>;

/**
 * Redux action, который записывает в store плюсы ЖК нового отзыва
 * @param pros string
 */
export const setProsRating: (pros: string) => TSetProsRating = actionGenerator<EProsActionTypes.Set, string>(
  EProsActionTypes.Set,
);
